import React from 'react';

export default function MedicalSupplies() {
  return <div>MedicalSupplies</div>;
}
